import { render } from "./VaccineRecordForm.vue?vue&type=template&id=da4cab1a"
import script from "./VaccineRecordForm.ts?vue&type=script&lang=js&external"
export * from "./VaccineRecordForm.ts?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__